/**
 * Made to match the Skapa InlineMessageVariant type.
 */
enum InlineMessageLayoutEnum {
	positive = 'positive',
	informative = 'informative',
	negative = 'negative',
	cautionary = 'cautionary'
}

export default InlineMessageLayoutEnum;
